import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer implements UrlSerializer {
  parse(url: string): UrlTree {
    const urlSer = new DefaultUrlSerializer();
    return urlSer.parse(url);
  }

  serialize(tree: UrlTree): string {
    const urlSer = new DefaultUrlSerializer(),
      path = urlSer.serialize(tree);
    return path.replace(/%2F/g, '/');
  }
}
